﻿<app-card #card [cardTitle]="'PASSWORD.SET_NEW_PASSWORD' | translate" 
    [formGroup]="mainForm" 
    (ok)="changePassword()"
    [showEdit]="!passwordResetMode" 
    [actionState]="{editMode: passwordResetMode}">

    <div class="flex-vertical" slot="edit">
        <div class="alert alert-danger" *ngIf="passwordResetMode && passwordResetFailed">
            {{ 'PASSWORD.RESET_LINK_INVALID' | translate }} <br>
            <a [routerLink]="['/']">{{ 'PASSWORD.BACK_TO_MAIN' | translate }}</a>
        </div>

        <input *ngIf="!ownProfile" type="password" style="display:none"/>

        <mat-form-field appearance="outline" *ngIf="!passwordResetMode && ownProfile">
            <mat-label>{{ 'PASSWORD.OLD_PASSWORD' | translate }}</mat-label>
            <input matInput type="password" name="oldPassword" formControlName="oldPassword" autocomplete="off" required>
            <mat-error msg></mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="username" *ngIf="passwordResetMode">
            <mat-label>{{ 'PASSWORD.USERNAME' | translate }}</mat-label>
            <input matInput type="text" name="username" formControlName="username" autocomplete="username">
            <mat-error msg></mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{ 'PASSWORD.NEW_PASSWORD' | translate }}</mat-label>
            <input matInput type="password" name="newPassword" formControlName="newPassword" autocomplete="new-password" required>
            <mat-error msg></mat-error>
        </mat-form-field>

        <div class="password-rules flex-v" *ngIf="isPasswordNotEmpty">
            <label class="col"
            [ngClass]="mainForm.controls['newPassword'].hasError('required') || mainForm.controls['newPassword'].hasError('minlength')  ? 'text-danger' : 'text-success'"
            >
            <i class="material-icons">
                {{ mainForm.controls['newPassword'].hasError('required') ||
                mainForm.controls['newPassword'].hasError('minlength') ? 'cancel' :
                'check_circle' }}
            </i>
            {{ 'PASSWORD.MIN_LENGTH' | translate:{minCharCount: minCharCount} }}
            </label>

            <label class="col"
            [ngClass]="mainForm.controls['newPassword'].hasError('required') || mainForm.controls['newPassword'].hasError('hasNumber')  ? 'text-danger' : 'text-success'"
            >
            <i class="material-icons">
                {{ mainForm.controls['newPassword'].hasError('required') ||
                mainForm.controls['newPassword'].hasError('hasNumber') ? 'cancel' :
                'check_circle' }}
            </i>
            {{ 'PASSWORD.MUST_CONTAIN_NUMBER' | translate }}
            </label>

            <label class="col"
            [ngClass]="mainForm.controls['newPassword'].hasError('required') || mainForm.controls['newPassword'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'"
            >
            <i class="material-icons">
                {{ mainForm.controls['newPassword'].hasError('required') ||
                mainForm.controls['newPassword'].hasError('hasCapitalCase') ? 'cancel' :
                'check_circle' }}
            </i>
            {{ 'PASSWORD.MUST_CONTAIN_UPPERCASE' | translate }}
            </label>

            <label class="col"
            [ngClass]="mainForm.controls['newPassword'].hasError('required') || mainForm.controls['newPassword'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'"
            >
            <i class="material-icons">
                {{ mainForm.controls['newPassword'].hasError('required') ||
                mainForm.controls['newPassword'].hasError('hasSmallCase') ? 'cancel' :
                'check_circle' }}
            </i>
            {{ 'PASSWORD.MUST_CONTAIN_LOWERCASE' | translate }}
            </label>

        </div>

        <mat-form-field appearance="outline" class="margin-top-lg">
            <mat-label>{{ 'PASSWORD.CONFIRM_PASSWORD' | translate }}</mat-label>
            <input matInput type="password" name="confirmPassword" formControlName="confirmPassword" autocomplete="new-password" required>
            <mat-error msg></mat-error>
        </mat-form-field>

        
    </div>

</app-card>
